"use strict";
var change_detection_util_1 = require("./change_detection/change_detection_util");
exports.SimpleChange = change_detection_util_1.SimpleChange;
var constants_1 = require("./change_detection/constants");
exports.ChangeDetectionStrategy = constants_1.ChangeDetectionStrategy;
var change_detector_ref_1 = require("./change_detection/change_detector_ref");
exports.ChangeDetectorRef = change_detector_ref_1.ChangeDetectorRef;
//# sourceMappingURL=change_detection.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-metadata/src/core/change_detection.js
// module id = 422
// module chunks = 0